import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { types as actions, setApDetailAction } from '../../reducers/actions';
import { AccessPointService } from '../../services';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.GET_AP_DETAIL),
    switchMap(action =>
      AccessPointService.getAll(action.siteId, store).pipe(
        map(data => {
          return setApDetailAction(data);
        })
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/status/getAccessPoint.js